import React from 'react';
import { VirtualBg } from '../../../../stores/types/content';
import BlurredImgBg from '../../../../images/blurred.png';
import * as l from './elements';

interface OwnProps {
	blur: 'high' | 'low',
	text: string,
	onSelect: (background: VirtualBg) => void,
	cssBlur: number,
	active: boolean
}

export default function VbgCardBlur(props: OwnProps) {
	const {
		blur,
		text,
		onSelect,
		cssBlur,
		active,
	} = props;

	return (
		<l.Card
			onMouseUp={(e) => {
				e.preventDefault();
				e.stopPropagation();
				onSelect({ url: '', blur, uniqueId: `blur_${blur}` });
			}}
			style={{ flex: 1 }}
		>
			<img src={BlurredImgBg} />
			<l.BlurCardLabel
				className='bl-font-header absolute-fill flex-center'
				style={{ backdropFilter: `blur(${cssBlur}px)` }}
			>
				{text}
			</l.BlurCardLabel>
			<l.SelectedOverlay hidden={!active} />
		</l.Card>
	);
}
